import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';

const TextBanner = ({ imageUrl, altname, title }) => {
  return (
    <>
       
        <section>
        <Container>
          <Row>
            <Col lg={12}>
             
              <img src={imageUrl} alt={altname} />
            </Col>
            <Col lg={12}>
              <div className='whowetxt'>

                <h3>{title}  </h3>
              </div>

            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default TextBanner



